(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-cart', class extends baseComponent.default {
      elements = {
        items: 'cart-items',
        subtotal: 'subtotal-price'
      };

      render() {
        this.listenTo('cartChange', (e, data) => {
          const source = data.html.querySelector('main-cart');

          source.hasAttribute('is-empty')
            ? this.setAttribute('is-empty', '')
            : this.removeAttribute('is-empty');

          this.$subtotal.replaceChildren(...data.html.querySelector(this.elements.subtotal).childNodes);
          // this.$subtotal.innerText = data.html.querySelector(this.elements.subtotal).innerText;
        })




 function slideDown(element) {
    if (element.style.height === 'auto') {
      return;
    }

    // To do the animation we temporarily hide it, check the height, and transition to it
    element.style.height = element.firstElementChild.scrollHeight + 'px';

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === 'height') {
        element.style.height = 'auto'; // Allows the content to grow normally
        element.removeEventListener('transitionend', transitionEnded);
      }
    };

    element.addEventListener('transitionend', transitionEnded);
  }
  
  function CountrySelector(countrySelect, provinceSelect) {

    var _this = {};
    _this.countrySelect = countrySelect;
    _this.provinceSelect = provinceSelect;


    if (_this.countrySelect && _this.provinceSelect) {

      function _onCountryChanged() {

        var selectedOption = _this.countrySelect.options[_this.countrySelect.selectedIndex],
            provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');

        // First remove all options
        _this.provinceSelect.innerHTML = '';

        if (provinces.length === 0) {
          _this.provinceSelect.parentNode.style.display = 'none';
          return;
        }

        // We need to build the provinces array
        provinces.forEach(function (data) {
          _this.provinceSelect.options.add(new Option(data[1], data[0]));
        });

        _this.provinceSelect.parentNode.style.display = 'block';
      }

      _this.countrySelect.addEventListener('change', _onCountryChanged);

      // Check first the default value of country
      var defaultCountry = _this.countrySelect.getAttribute('data-default');

      if (defaultCountry) {
        for (var i = 0; i !== _this.countrySelect.options.length; ++i) {
          if (_this.countrySelect.options[i].text === defaultCountry) {
            _this.countrySelect.selectedIndex = i;
            break;
          }
        }
      } else {
        _this.countrySelect.selectedIndex = 0;
      }

      var event = new Event('change', { bubbles: true });
      _this.countrySelect.dispatchEvent(event);

      // Then the province
      var defaultProvince = _this.provinceSelect.getAttribute('data-default');

      if (defaultProvince) {
        _this.provinceSelect.value = defaultProvince;
      }

    }
  }

  function formatMoney(cents, format) {
				if (typeof cents === 'string') {
				cents = cents.replace('.', '');
				}
		
				var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
					formatString = format || '${{amount}}';
		
				function defaultTo(value, defaultValue) {
				return value == null || value !== value ? defaultValue : value;
				}
		
				function formatWithDelimiters(number, precision, thousands, decimal) {
				precision = defaultTo(precision, 2);
				thousands = defaultTo(thousands, ',');
				decimal = defaultTo(decimal, '.');
		
				if (isNaN(number) || number == null) {
					return 0;
				}
		
				number = (number / 100.0).toFixed(precision);
		
				var parts = number.split('.'),
					dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
					centsAmount = parts[1] ? decimal + parts[1] : '';
		
				return dollarsAmount + centsAmount;
				}
		
				var value = '';
		
				switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_space_separator':
					value = formatWithDelimiters(cents, 2, ' ', '.');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, ',', '.');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				}
		
				if (formatString.indexOf('with_comma_separator') !== -1) {
				return formatString.replace(placeholderRegex, value).replace(',00', '');
				} else {
				return formatString.replace(placeholderRegex, value).replace('.00', '');
				}
			}
  
  function ShippingEstimator(element) {

    var _this = {};

    _this.element = element;
    _this.countrySelector = CountrySelector(_this.element.querySelector('[name="country"]'), _this.element.querySelector('[name="province"]'));

    function _fetchRates() {

      var country = _this.element.querySelector('[name="country"]').value,
          province = _this.element.querySelector('[name="province"]').value,
          zip = _this.element.querySelector('[name="zip"]').value;

		
      
      fetch(window.theme.localeRootUrl + '/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.json().then(function (result) {

          
          var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
              errorContainer = _this.element.querySelector('.ShippingEstimator__Error');

          if (response.ok) {
            var shippingRates = result['shipping_rates'];

            if (shippingRates.length === 0) {
              resultsContainer.innerHTML = '<p>' + window.languages.shippingEstimatorNoResults + '</p>';
            } else {
              var html = '';

              if (shippingRates.length === 1) {
                html += '<p>' + window.languages.shippingEstimatorOneResult + '</p><ul>';
              } else {
                html += '<p>' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul>';
              }

              shippingRates.forEach(function (item) {
                html += '<li>' + item['name'] + ': ' + formatMoney(item['price'], window.theme.moneyFormat) + '</li>';
              });

              html += '</ul>';

              resultsContainer.firstElementChild.innerHTML = html;
            }

            // TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, { autoAlpha: 0, y: -15 }, { autoAlpha: 1, y: 0, delay: 0.35 });

            errorContainer.style.display = 'none';
            resultsContainer.style.display = 'block';

            slideDown(resultsContainer);
          } else {
            var errorHtml = '';

            Object.keys(result).forEach(function (key) {
              errorHtml += '<li class="Alert__ErrorItem">' + key + ' ' + result[key] + '</li>';
            });

            errorContainer.innerHTML = '<ul class="Alert__ErrorList">' + errorHtml + '</ul>';

            resultsContainer.style.display = 'none';
            errorContainer.style.display = 'block';
          }
        });
      });
    }

    var ShippingEstimator__SubmitEl = _this.element.querySelector('.ShippingEstimator__Submit');
    if(ShippingEstimator__SubmitEl) {
    	ShippingEstimator__SubmitEl.addEventListener('click', function(e){
          e.preventDefault();
          _fetchRates();
        });
    }
  }

  var ShippingEstimatorEl = document.querySelector('.ShippingEstimator');
  if(ShippingEstimatorEl) {
    ShippingEstimator(ShippingEstimatorEl);
  }







        
      }
      update(callback) {
        fetch(`${this.getAttribute('cart-url')}?section_id=${this.sectionId}`).then((response) => {
          return response.text();
        })
        .then((text) => {
          const parsedHtml = new DOMParser().parseFromString(text, 'text/html');
          const source = parsedHtml.querySelector('main-cart');

          source.hasAttribute('is-empty')
            ? this.setAttribute('is-empty', '')
            : this.removeAttribute('is-empty');

          this.$items.replaceChildren(...source.querySelector(this.elements.items).childNodes);
          this.$subtotal.replaceChildren(...source.querySelector(this.elements.subtotal).childNodes);
          callback();
        })
        .catch((e) => { console.error(e)});
      }
  });

  customElements.define('s-subtotal-price', class extends baseComponent.default {
    render() {
      this.listenTo('cartChange', (e, data) => {
        const source = data.html.querySelector('subtotal-price');
        this.replaceChildren(...source.childNodes);

      })
    }
  });

  customElements.define('cart-item', class extends baseComponent.default {
    elements = {
      plusButton: '[data-inc]',
      minusButton: '[data-dec]',
      removeButton: '[data-remove]',
      qtyInput: '[data-input]',
      linePrice: '[data-total]'
    }


    render() {
      this.sectionId = this.getAttribute('section-id');
      this.lineIndex = this.getAttribute('line-item-index');
      this.variantId = this.getAttribute('cart-item-variant-id');
      this.qtyValue = +this.$qtyInput.value;
      this.variantQtyLimit = +this.$qtyInput.max;
      this._handleInteractions();
    };

    _handleInteractions() {
      this.$plusButton.addEventListener('click', () => this._validateInput(1));
      this.$minusButton.addEventListener('click', () => this._validateInput(-1));
      this.$qtyInput.addEventListener('change', () => this._validateInput());
      this.$removeButton.addEventListener('click', this._removeItem.bind(this));
    };

    _validateInput(input) {
      const value = input ? this.qtyValue + input : +this.$qtyInput.value;
      if (value < 1 || (this.variantQtyLimit && value > this.variantQtyLimit)) {
        // alert('Incorrect quantity!')
        // console.log('wrong quanity')
        this.$qtyInput.value = this.qtyValue;
        return
      }
      this.qtyValue = value;
      this._updateUI();
      this._updateCartRequest(value);
    };

    _removeItem(e) {
      e.preventDefault();
      this._updateCartRequest(0);
    };

    _updateUI() {
      this._updateInputValue();
      this._updateButtons();
    };
    
    _updateInputValue() {
      this.$qtyInput.value = this.qtyValue;
    };

    _updateButtons() {
      this.$plusButton.disabled = this.qtyValue === this.variantQtyLimit;
      this.$minusButton.disabled = this.qtyValue === 1;
    };

    _updateCartRequest (qty) {
      var ShippingEstimator__Results = document.querySelector(".ShippingEstimator__Results");
      if(ShippingEstimator__Results){
        ShippingEstimator__Results.style.display = "none";
      }
      this.setAttribute('loading', '');
      const body = JSON.stringify({
        id: this.variantId,
        quantity: qty,
        sections: this.sectionId,
        sections_url: this.getAttribute('cart-url')
      });
      const fetchConfig = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
      };
      fetch(`${routes.cart_change_url}`, {...fetchConfig, ...{ body }})
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          const html = state.sections[this.sectionId];
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
          this._acceptChanges(parsedHtml, qty);
          this.removeAttribute('loading');
        })
        .catch((e) => { console.error(e)});
    };

    _acceptChanges(html, qty) {
      // console.log('sending evt');
      this.forwardEvent('cartChange', {
        html: html,
        remove: qty === 0,
        variantId: this.variantId
      });
      if (qty === 0) {
        this.remove();
        return;
      }
      this._updateLinePrice(html);
    };

    _updateLinePrice(html) {
      const source = html.querySelector(`[data-total="${this.variantId}"]`);
      this.$linePrice.replaceChildren(...source.childNodes);
    };
  });

})();